var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-empty',{attrs:{"description":"该功能暂未开放"}})}
var staticRenderFns = []

export { render, staticRenderFns }